import { IconName, PropertyColor } from '@thiememeulenhoff/types';
import { html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { IconSize } from '@thiememeulenhoff/tokens';
import { ButtonComponent } from '..';
import { styles, tag } from './icon-button.styles';

@customElement(tag)
export class IconButtonComponent extends ButtonComponent {
  static override styles = styles;

  @property({ type: Boolean })
  underlined = false;

  @property({ type: Boolean })
  indicator = false;

  @property({ type: String })
  icon: IconName = 'user';

  @property({ type: String, reflect: true })
  override color: PropertyColor = 'blue';

  @property({ type: String, attribute: 'icon-size' })
  iconSize: IconSize = 'large';

  @property({ type: String })
  label = '';

  override render() {
    const content = html` <a-icon
        part="icon"
        name="${this.icon}"
        size="${this.iconSize}"
      ></a-icon>
      ${this.renderLabel()} ${this.renderIndicator()}`;

    const ariaLabel = this.#ariaLabel();

    if (this.href) {
      return html`<a
        part="button"
        class="button ${!this.label ? 'without-content' : ''}"
        href=${this.disabled ? nothing : this.href}
        target=${this.target ?? nothing}
        ?disabled=${this.disabled}
        ?underlined=${this.underlined}
        aria-label="${ariaLabel ?? nothing}"
        >${content}</a
      >`;
    }

    return html`<button
      part="button"
      class="button ${!this.label ? 'without-content' : ''}"
      aria-label="${ariaLabel ?? nothing}"
      ?disabled=${this.disabled}
      ?underlined=${this.underlined}
      @click=${this.handleClick}
    >
      ${content}
    </button>`;
  }

  #ariaLabel() {
    // If the host has an aria-label, we only add an aria-label if we have a label
    if (this.ariaLabel) {
      return this.label || null;
    }

    return this.label || this.icon;
  }

  renderLabel() {
    return this.label.length > 0 ? html`<label>${this.label}</label>` : nothing;
  }

  renderIndicator() {
    return this.indicator ? html`<div class="indicator"></div>` : nothing;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'a-icon-button': IconButtonComponent;
  }
}
